import React from "react";
import {Breadcrumb, Button, Card, Col, Form, Input, Row, Tabs} from "antd";
import {Link} from "react-router-dom";

import BaseComponent from "../../redare/components/BaseComponent";
import TaskReceiverGrid from "../../components/workbench/TaskReceiverGrid";
import DictSelect from "../../components/common/DictSelect";

const {TabPane} = Tabs;

export default class TaskReceiverPage extends BaseComponent {

    formRef = React.createRef();

    constructor(props) {
        super(props);
    }

    _queryTask() {
        this.formRef.current.validateFields()
            .then(value => {
                this.taskReceiverGrid._findTaskReceiverPage(value)
            })
    }

    render() {
        return (
            <div className="PendingTasks-Page">
                <div className="bg-white bord-bot">
                    <div className="width-all padding02">
                        <Breadcrumb>
                            <Breadcrumb.Item><Link to="/">工作台</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>待办任务</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="width-all bg-white">
                    <div className="margin024">
                        <Card bordered={false}>
                            <Row gutter={[16]} justify="space-between">
                                <Col span={20}>
                                    <Form className="information-form" ref={this.formRef}>
                                        <Row gutter={16} justify="end">
                                            <Col span={6}>
                                                <Form.Item label="任务来源" name="sysCode">
                                                    <DictSelect code={"task_origin"} matchkey="dicCode"/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item name="key">
                                                    <Input placeholder="请输入关键字"/>
                                                </Form.Item>
                                            </Col>
                                            <Col>
                                                <Button type="primary" onClick={() => this._queryTask()}>查询</Button>
                                            </Col>
                                            <Col>
                                                <Button onClick={() => this.formRef.current.resetFields()}>重置</Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                            <Tabs defaultActiveKey="1">
                                <TabPane tab={<><span>待办事项</span></>} key="1">
                                    <TaskReceiverGrid showPage={true} ref={(the) => this.taskReceiverGrid = the} tabIndex="1"/>
                                </TabPane>
                            </Tabs>
                        </Card>

                    </div>
                </div>
            </div>
        )
    }
}
